import { useLayoutEffect } from 'react'
import { WhiteLabelBrandSettingsInterface } from 'src/shared/types/brand-settings-interface'
import { whiteLabelBrandSettingsQuery } from '../api/queries/white-label-brand-query'
import { isCustomDomain } from '../shared/utils/is-custom-domain'
import {
  adjustColorGroup,
  semanticColorGroups,
} from '../shared/utils/white-label-brand'

const applyWhiteLabelBrandSettings = (
  colors: WhiteLabelBrandSettingsInterface['colors'],
  favicon: WhiteLabelBrandSettingsInterface['favicon'],
) => {
  if (colors) {
    const root = document.documentElement

    const brandPrimaryVariables = adjustColorGroup(
      colors.oldBrandPrimary,
      semanticColorGroups[0],
    )
    const brandTextPrimaryVariables = adjustColorGroup(
      colors.oldTextPrimary,
      semanticColorGroups[1],
    )
    const brandTextLinkVariables = adjustColorGroup(
      colors.oldBrandPrimary,
      semanticColorGroups[2],
    )

    Object.entries(
      Object.assign(
        {},
        brandPrimaryVariables,
        brandTextPrimaryVariables,
        brandTextLinkVariables,
      ),
    ).forEach(([variable, value]) => {
      root.style.setProperty(variable, value)
    })
  }
  if (favicon) {
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = favicon.path
  }
}

export const useWhiteLabelBrandSettings = () => {
  const { data: brandSettings } = whiteLabelBrandSettingsQuery.useQuery({
    options: {
      enabled: isCustomDomain(),
    },
  })

  useLayoutEffect(() => {
    if (brandSettings) {
      applyWhiteLabelBrandSettings(brandSettings.colors, brandSettings.favicon)
    }
  }, [brandSettings])

  return { brandSettings }
}
